"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipTitleStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _tooltipTheme = require("../tooltipTheme");
const TooltipTitleStyled = (0, _styled.default)("div")`
    // We can't use the TypeRampV2 component here because the TypeRampV2 component uses the Tooltip
    // so we'd have a circular dependency.
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _tooltipTheme.tooltipTheme.fontSize.multiLineTitle(themeMode);
}};
    font-weight: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _tooltipTheme.tooltipTheme.fontWeight.title(themeMode);
}};
    line-height: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _tooltipTheme.tooltipTheme.lineHeight.title(themeMode);
}};

    color: var(--sds--tooltip--text-color, ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _tooltipTheme.tooltipTheme.textColor.title(themeMode);
}});

    padding: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _tooltipTheme.tooltipTheme.padding.multiLine.title(themeMode);
}};
`;
exports.TooltipTitleStyled = TooltipTitleStyled;
//# sourceMappingURL=TooltipTitleStyled.js.map